/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRestart = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M19.992 11.633A7.771 7.771 0 0 1 20 12c0 .356-.023.706-.068 1.047l1.984.26c.055-.428.084-.864.084-1.307 0-5.523-4.477-10-10-10a9.985 9.985 0 0 0-8 3.999V3H2v6h6V7H5.754a8 8 0 0 1 14.238 4.633zM2.05 11a10.118 10.118 0 0 0 .035 2.306l1.983-.259A8.095 8.095 0 0 1 4.062 11zm2.556 4.062-1.847.766a9.988 9.988 0 0 0 1.307 2.26l1.586-1.219a7.989 7.989 0 0 1-1.046-1.807zm2.524 3.286-1.218 1.586c.688.529 1.447.97 2.26 1.307l.766-1.847a7.988 7.988 0 0 1-1.807-1.046zm3.823 1.584-.26 1.984a10.105 10.105 0 0 0 2.613 0l-.259-1.984a8.095 8.095 0 0 1-2.094 0zm4.109-.538.766 1.847a9.987 9.987 0 0 0 2.26-1.307l-1.219-1.586a7.987 7.987 0 0 1-1.807 1.046zm3.286-2.524 1.586 1.218a9.987 9.987 0 0 0 1.307-2.26l-1.847-.766a7.987 7.987 0 0 1-1.046 1.807z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRestart as Restart };
